import { Close } from "@mui/icons-material";
import { Box, Divider, Drawer, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TooltipIconButton } from "../../../../../components/shared";
import { DateFilter } from "./DateFilter";
import { ProjectUsersFilter } from "./ProjectUsersFilter";
import { OptionsFilter } from "./OptionsFilter";

function FiltersDrawer({ isOpen, onClose, filters, setFilters }) {
  const { t: tGeneral } = useTranslation("general");
  const { t: tStatus } = useTranslation("status");
  const [tempFilters, setTempFilters] = useState({
    range: [
      {
        startDate: null,
        endDate: null,
        key: "selection",
      },
    ],
    createdBy: [],
    assignedTo: [],
    status: [],
  });

  useEffect(() => {
    setTempFilters({
      range: [
        {
          startDate: filters?.startDate ?? null,
          endDate: filters?.endDate ?? null,
          key: "selection",
        },
      ],
      createdBy: filters?.createdBy ?? [],
      assignedTo: filters?.assignedTo ?? [],
      status: filters?.status ?? [],
    });
  }, [filters]);

  const handleChange = (name, value) => {
    const newValues = { ...tempFilters };
    newValues[name] = value;
    setTempFilters(newValues);
  };

  const handleClose = () => {
    setFilters({
      ...filters,
      status: tempFilters.status,
      createdBy: tempFilters.createdBy,
      assignedTo: tempFilters.assignedTo,
      startDate: tempFilters.range[0].startDate,
      endDate: tempFilters.range[0].endDate,
    });
    onClose();
  };

  return (
    <Drawer open={isOpen} onClose={handleClose} anchor="right">
      <Box>
        <Box display="flex" alignItems="center" p="1rem 0.5rem 0 0.5rem">
          <Typography flex={1} fontSize="1.25rem" px="0.5rem">
            {tGeneral("filters")}
          </Typography>
          <TooltipIconButton
            icon={<Close />}
            onClick={handleClose}
            label={tGeneral("close")}
            color="black"
          />
        </Box>
        <Divider sx={{ my: "0.5rem" }} />
        <Box display="flex" flexDirection="column" px="0.5rem">
          <Typography fontSize="0.75rem" px="0.5rem">
            {tGeneral("filterBy")}
          </Typography>
          <DateFilter
            value={tempFilters.range}
            onChange={(newVal) => handleChange("range", newVal)}
          />
          <ProjectUsersFilter
            value={tempFilters.assignedTo}
            onChange={(newVal) => handleChange("assignedTo", newVal)}
            title={tGeneral("assigned")}
          />
          <ProjectUsersFilter
            value={tempFilters.createdBy}
            onChange={(newVal) => handleChange("createdBy", newVal)}
            title={tGeneral("createdBy")}
          />
          <OptionsFilter
            value={tempFilters.status}
            onChange={(newVal) => handleChange("status", newVal)}
            title={tGeneral("status")}
            options={[
              { value: "open", label: tStatus("open") },
              { value: "closed", label: tStatus("closed") },
              { value: "draft", label: tStatus("draft") },
            ]}
          />
        </Box>
      </Box>
    </Drawer>
  );
}

export { FiltersDrawer };
